// Función para formatear fecha
export const formatDateWithoutTimeZoneIssues = (isoString) => {
    // Dividir la fecha y hora para ignorar la zona horaria
    const [datePart] = isoString.split("T");
    const [year, month, day] = datePart.split("-");

  
    // Crear fecha local sin considerar la hora/UTC
    return new Date(year, month - 1, day).toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

export const formatDateWithoutTimeZoneDatePicker = (isoString) => {
  if (!isoString) return null;
  const [datePart] = isoString.split("T");
  const [year, month, day] = datePart.split("-");
  return `${day}/${month}/${year}`; // solo para mostrar
};